import { useAuthStore } from '../stores/UserAuth'
import { getCookie } from '../utils/Cookie'
import commonConfig from '../configs/common'

export default {
  install: (app) => {
    // 获取认证store
    const authStore = useAuthStore()
    
    // 在应用挂载前检查登录状态
    if (typeof window !== 'undefined') {
      // 延迟执行以避免阻塞页面渲染
      setTimeout(() => {
        authStore.checkAuth()
      }, 0)
    }
  }
} 